/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropDown from 'app/components/common/DropDown.jsx';
import ShortenerFilterItem from 'app/components/DropDownItems/ShortenerFilterItem.jsx';
import DropdownButton from 'app/components/common/DropdownButton.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class ShortenerHeader extends React.Component {
    render() {
        let filterBox = null,
            options = [],
            constants = this.props.app.config.constants,
            total = 0;

        if (this.props.showFilter) {
            for (let key in this.props.shorteners) {
                key = parseInt(key, 10);
                if (key === constants.SHORTEN_SVC_BITLY) {
                    options.push({id: key, type: key, name: 'bit.ly', count: this.props.shorteners[key]});
                    total += this.props.shorteners[key];
                } else if (key === constants.SHORTEN_SVC_CUSTOM) {
                    options.push({id: key, type: key, name: '3rd Party Shortener', count: this.props.shorteners[key]});
                    total += this.props.shorteners[key];
                } else if (key === constants.PUB_DOMAIN) {
                    options.push({id: key, type: key, name: 'Custom Domain', count: this.props.shorteners[key]});
                    total += this.props.shorteners[key];
                }
            }

            options = _.sortBy(options, function(option){
                return option.name.toLowerCase();
            });

            // add 2 for all for "no link" and "dlvr.it"
            options.push({id: '', type: '', name: 'All Shorteners', count: total + 2});

            filterBox = (
                <DropDown
                    id="filter"
                    items={options}
                    itemElement={ShortenerFilterItem}
                    dropDownClass="filter-dd"
                    clickHandler={this.props.onFilter}
                    resetHandler={this.props.resetHandler} />
            );
        }

        return (
            <div className="content-header">
                <Breakpoint desktop only>
                <div className="control-bar">
                    <DropdownButton
                        controlClass="solo"
                        label={this.props.filterLabel}
                        action={this.props.onShowFilter} />

                    <div className="control connect shortener" onClick={this.props.onAddShortener} role="button" aria-label="add shortener">
                        <div className="control-wrapper">
                            <span className="va-helper"></span>
                            <span className="control-icon">
                                <i className="fa fa-plus-square"></i>
                            </span>
                            <span className="control-label">Add a Shortener</span>
                        </div>
                    </div>
                </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="mobile-control-bar">
                        <div className="control new shortener" onClick={this.props.onAddShortener} role="button" aria-label="add shortener">
                            <i className="fa fa-plus-square"></i> Add Shortener
                        </div>
                        <div className="control-row border">
                            <DropdownButton
                                controlClass="with-padding"
                                label={this.props.filterLabel}
                                action={this.props.onShowFilter} />
                        </div>
                    </div>
                </Breakpoint>
                {filterBox}
            </div>
        );
    }

};

ShortenerHeader.displayName = "ShortenerHeader";

ShortenerHeader.propTypes = {
    shorteners: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    onShowFilter: PropTypes.func,
    onFilter: PropTypes.func,
    onAddShortener: PropTypes.func,
    showFilter: PropTypes.bool,
    resetHandler: PropTypes.func
};

ShortenerHeader.defaultProps = {
    shorteners: [],
    onFilter: null,
    onShowFilter: null,
    onAddShortener: null,
    showFilter: false,
    resetHandler: null,
    filterLabel: 'All Shorteners'
};

export default ShortenerHeader;
